import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import LargeItemStatus from "../../../../../../common/components/large_item_status";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";
import dayjs from "dayjs";
import ItemStatus from "../../../../../../common/components/item_status";

type Props = {
  onActionEditar: (id: number | null, openState: boolean) => void;
  onActionDeletar: (id: number | null, openState: boolean) => void;
  onActionCopiar: (id: number | null, openState: boolean) => void;
  onActionExportar: (id: number) => void;
};

export const GenerateDiarioObraColumns = ({
  onActionEditar,
  onActionDeletar,
  onActionCopiar,
  onActionExportar,
}: Props): GridColDef[] => {
  const computeDiaPraticavelTitle = (status: number) => {
    switch (status) {
      case 0:
        return "Não";
      case 1:
        return "Sim";
      case 2:
        return "Parcial";
      default:
        return "?";
    }
  };

  const computeDiaPraticavelColor = (status: number) => {
    switch (status) {
      case 0:
        return "red";
      case 1:
        return "blue";
      case 2:
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeDiaPraticavelDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Não";
      case 1:
        return "Sim";
      case 2:
        return "Parcial";
      default:
        return "?";
    }
  };

  const computeCondicaoTempoTitle = (status: string) => {
    switch (status) {
      case "B":
        return "Bom";
      case "C":
        return "Chuvoso";
      case "N":
        return "Nublado";
      default:
        return "?";
    }
  };

  const computeCondicaoTempoColor = (status: string) => {
    switch (status) {
      case "B":
        return "blue";
      case "C":
        return "red";
      case "N":
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeCondicaoTempoDescription = (status: string) => {
    switch (status) {
      case "B":
        return "Bom";
      case "C":
        return "Chuvoso";
      case "N":
        return "Nublado";
      default:
        return "?";
    }
  };

  //#region Status
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 0:
        return "E";
      case 1:
        return "A";
      case 2:
        return "LP";
      default:
        return "?";
    }
  };
  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "red";
      case 1:
        return "green";
      case 2:
        return "blue";
      default:
        return "blue";
    }
  };
  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Em elaboração";
      case 1:
        return "Aprovado";
      case 2:
        return "Liberado para aprovação";
      default:
        return "?";
    }
  };

  //#endregion

  return [
    {
      field: "Status",
      filterable: false,
      headerName: "Status",
      width: 70,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      ),
    },
    {
      field: "NroDiario",
      filterable: false,
      headerName: "Nº",
      width: 70,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Cliente",
      filterable: false,
      headerName: "Cliente",
      minWidth: 220,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "NomeCentroCusto",
      filterable: false,
      headerName: "Centro Custo",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "CondicaoTempo",
      filterable: false,
      headerName: "Condição Tempo",
      width: 98,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={computeCondicaoTempoTitle(params.value)}
            color={computeCondicaoTempoColor(params.value)}
            description={computeCondicaoTempoDescription(params.value)}
          />
        </div>
      ),
    },
    {
      field: "DiaPraticavel",
      filterable: false,
      headerName: "Dia Praticável",
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={computeDiaPraticavelTitle(params.value)}
            color={computeDiaPraticavelColor(params.value)}
            description={computeDiaPraticavelDescription(params.value)}
          />
        </div>
      ),
    },
    {
      field: "InicioPrevisto",
      filterable: false,
      headerName: "Início Previsto",
      width: 90,
      sortable: false,
      renderCell: (params) => {
        return (
          <span className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {params.value && dayjs(params.value).format("DD/MM/YYYY")}
          </span>
        );
      },
    },
    {
      field: "FuncionariosProprio",
      filterable: false,
      headerName: "Funcionários Próprios",
      width: 112,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "FuncionariosTerceirizados",
      filterable: false,
      headerName: "Funcionários Terceirizados",
      width: 115,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "HorasParalisacao",
      filterable: false,
      headerName: "Horas Paralisacao",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "AprovadoPor",
      filterable: false,
      headerName: "Aprovado Por",
      flex: 1,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "DataHora",
      filterable: false,
      headerName: "Data e Hora aprovado",
      sortable: false,
      renderCell: (params) => {
        if (params.row.DataHora && params.row.AprovadoPor) {
          return (
            <div className="break-normal w-full h-full flex justify-center items-center text-center text-xs py-2">
              <span>
                {dayjs(params.row.DataHora).format("DD/MM/YYYY HH:mm")}
              </span>
            </div>
          );
        }
        return null;
      },
    },
    {
      field: "IdDiarioObras",
      headerName: "Ações",
      sortable: false,
      filterable: false,
      width: 190,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon
              nameIcon="EditRounded"
              size={25}
              className="dark:text-white text-primary-green"
            />
          </IconButton>

          <IconButton onClick={() => onActionCopiar(params.value, true)}>
            <DynamicIcon
              nameIcon="ContentCopyRounded"
              size={22}
              className="dark:text-white text-gray-500"
            />
          </IconButton>

          <Button
            onMouseDown={(e) => {
              if (e.button === 1) {
                onActionExportar(params.value);
              } else {
                onActionExportar(params.value);
              }
              e.preventDefault();
            }}
            sx={{
              fontSize: 11,
              paddingX: ".4rem",
              paddingY: 0,
              background: "#e6e6e6",
              borderLeft: ".2rem solid #45b6af",
              borderRadius: 0,
              color: "black",
              fontWeight: "normal",
            }}
          >
            Exportar
          </Button>

          <IconButton onClick={() => onActionDeletar(params.value, true)}>
            <DynamicIcon
              nameIcon="DeleteForeverRounded"
              size={25}
              className="text-red-500"
            />
          </IconButton>
        </div>
      ),
    },
  ];
};
